import { removeItemFromCart } from './cart-service.js';

// Cart page line-item remove helper
// Listens for clicks on [data-item-remove] within the main cart items
// surface and uses removeItemFromCart to sync with Shopify.
// Tempt patch. Remove function / lisener is handled by QC component, not the cart-items component 
// So when clicked in cart, there is no handler present. 
// This enables the button to work in both places, but is not ideal long term.
// Ideally, the list-items will hadle this internally and emit the required events that bubble to cart and QC.

(() => {
  const surface = document.querySelector('cart-items');
  if(!surface) return; // Only run on the full cart page

  const handleClick = async (event) => {
    const target = event.target;
    if(!target) return;
    const btn = target.closest('[data-item-remove]');
    if(!btn || !surface.contains(btn)) return;
    event.preventDefault();
    const cartKey = btn.getAttribute('data-item-key');
    if(!cartKey) return;
    const ok = await removeItemFromCart(cartKey);
    if(!ok) return;
    const line = btn.closest('cart-item');
    if(line && line.parentElement) line.parentElement.removeChild(line);
  };

  surface.addEventListener('click', handleClick);
})();